import LoginType, { forgetRequestType, forgetResponse, LoginResponse, resetRequestType } from '@components/Types/login/LoginTypes';
import { apiClient } from '../client';

export const postLogin = async(data:LoginType):Promise<LoginResponse> =>{
   const response= await apiClient.post<LoginResponse>(`/usermanagement/auth/enterprise/login`,data);
   return response.data;    
}



export const ForgetPassword = async(data:forgetRequestType):Promise<forgetResponse> =>{
   const response= await apiClient.post<forgetResponse>(`/usermanagement/auth/forgot-password`,data);
   return response.data;    
}

export const ResetPassword = async(data:resetRequestType):Promise<forgetResponse> =>{
   const response= await apiClient.post<forgetResponse>(`/usermanagement/auth/reset-password`,data);
   return response.data;    
}